<template>
  <Layout class="main">
    <Header class="header-bar-wrapper">
      <header-bar :collapsed="shrink" @on-coll-change="toggleClick">
        <div slot="logo" class="logo-wrapper">
          <img :src="Logo" alt="" key="max-logo" />
        </div>
        <user slot="right" :user-avator="avatorPath"></user>
      </header-bar>
    </Header>

    <Layout class="sider-wrapper">
      <!-- 左侧菜单导航 Start -->
      <Sider
        hide-trigger
        collapsible
        breakpoint="md"
        :width="256"
        :collapsed-width="60"
        v-model="shrink"
        class="left-sider"
      >
        <sider-menu
          ref="SiderMenu"
          accordion
          :collapsed="shrink"
          :shrink="shrink"
          theme="light"
          :active-name="$route.name"
          :menu-list="menuList"
          @on-select="turnToPage"
        ></sider-menu>
      </Sider>
      <!-- 左侧菜单导航 End -->

      <!-- 右侧主要内容显示区 Start -->
      <Layout>
        <Content style="height: 100%">
          <Layout style="height: 100%">
            <div class="navigation-tag-wrapper">
              <header-navigation-tag
                :currentRoute="$route"
                :headerNavigationTagList="headerNavigationTagList"
                @toLink="handleToLink"
                @on-close-tag="handleCloseTag"
              ></header-navigation-tag>
            </div>

            <header-bread-crumb
              :headerBreadCrumbList="headerBreadCrumbList"
            ></header-bread-crumb>

            <Content class="content-wrapper">
              <router-view />
            </Content>
          </Layout>
        </Content>
      </Layout>
      <!-- 右侧主要内容显示区 End -->
    </Layout>
  </Layout>
</template>

<script>
import SiderMenu from './sider/sider-menu';
import HeaderNavigationTag from './header/header-navigation-tag';
import HeaderBar from './header/header-bar';
import User from './header/header-avatar';
import HeaderBreadCrumb from './header/header-bread-crumb';
import LogoSimple from '@/assets/images/logo.simple.png';
import Logo from '@/assets/images/logo.png';
import routes from '@/router/routes';
import './main.less';
import {
  getNewTagList,
  getNextRoute,
  getHeaderBreadCrumbList,
  getMenuByRouter,
  routeHasExist,
  routeEqual,
  getHomeRoute,
} from './menu-util';

export default {
  components: {
    HeaderBar,
    User,
    SiderMenu,
    HeaderNavigationTag,
    HeaderBreadCrumb,
  },

  data() {
    return {
      shrink: false,
      LogoSimple,
      Logo,
      userName: '',
      headerNavigationTagList: [], // 导航标签列表
      headerBreadCrumbList: [], // 导航面包屑
    };
  },

  computed: {
    // 左侧菜单栏数组
    menuList() {
      let access = [''];
      return getMenuByRouter(routes, access);
    },
    // TODO 用户头像
    avatorPath() {
      return LogoSimple;
    },
  },

  methods: {
    // 设置面包屑
    setBreadCrumb(routeMatched) {
      this.headerBreadCrumbList = getHeaderBreadCrumbList(
        routeMatched,
        getHomeRoute(routes),
      );
    },

    // 设置导航标签列表
    setHeaderNavigationTagList(list) {
      this.headerNavigationTagList = list ? [...list] : [];
    },

    // 新增导航 tag，保持 home 永远第一位，并且不能被关闭
    addHeaderNavigationTag({ route, type = 'unshift' }) {
      if (!routeHasExist(this.headerNavigationTagList, route)) {
        if (type === 'push') {
          this.headerNavigationTagList.push(route);
        } else {
          if (route.name === 'home') {
            this.headerNavigationTagList.unshift(route);
          } else {
            this.headerNavigationTagList.splice(1, 0, route);
          }
        }
      }
    },

    // 控制左侧菜单缩放
    toggleClick() {
      this.shrink = !this.shrink;
    },

    // 路由跳转
    turnToPage(route) {
      // 路由转化
      let { name, params, query } = {};
      if (typeof route === 'string') {
        name = route;
      } else {
        name = route.name;
        params = route.params;
        query = route.query;
      }

      if (name.includes('isTurnByHref_')) {
        window.open(name.split('_')[1]);
        return;
      }

      this.$router.push({
        name,
        params,
        query,
      });
    },

    // 关闭标签
    handleCloseTag(tag, type, route) {
      let openName = '';
      if (type === 'all') {
        this.turnToPage('home');
        openName = 'home';
      } else if (routeEqual(this.$route, route)) {
        if (type === 'others') {
          openName = route.name;
        } else {
          const nextRoute = getNextRoute(this.headerNavigationTagList, route);
          this.$router.push(nextRoute);
          openName = nextRoute.name;
        }
      }
      this.setHeaderNavigationTagList(tag);
      // 点开 tag 显示相应的 menu
      this.$refs.SiderMenu.updateOpenName(openName);
    },

    // click tag 跳转相应试图
    handleToLink(item) {
      this.turnToPage(item);
    },
  },

  watch: {
    $route(to) {
      this.setBreadCrumb(to.matched);
      const isNoTag = to.meta.noTag; // 增加 notag 标志位
      if (!isNoTag) {
        this.setHeaderNavigationTagList(
          getNewTagList(this.headerNavigationTagList, to),
        );
      }
    },
  },

  mounted() {
    // DESC: 初始化设置面包屑导航和标签导航
    this.setHeaderNavigationTagList();
    this.addHeaderNavigationTag({
      route: getHomeRoute(routes),
    });
    this.setBreadCrumb(this.$route.matched);
  },
};
</script>
